import {visible} from "./visible";
import {combineReducers} from "redux";


/**
 * create reducer to handle debug console properties
 * @type {Reducer<any>}
 */
export const debugConsole = combineReducers({
    visible
});


// WEBPACK FOOTER //
// ./src/ts/store/reducers/debug-console/debugConsole.ts